import { render } from "./DriverDetails.vue?vue&type=template&id=4b542b73&scoped=true"
import script from "./DriverDetails.vue?vue&type=script&lang=js"
export * from "./DriverDetails.vue?vue&type=script&lang=js"

import "./DriverDetails.vue?vue&type=style&index=0&id=4b542b73&lang=scss&scoped=true"

import exportComponent from "/home/newbuyanyinsuran/public_html/wizards/car.buyanyinsurance.ae/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b542b73"]])

export default __exports__